var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-deutsche-bank") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header-desktop",
    transform: "translate(-1243.000000, -24.000000)",
    fill: "#0018A8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-deutsche-bank",
    transform: "translate(1243.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L48,0 L48,48 L0,48 L0,0 Z M6.81081081,6.81081081 L6.81081081,41.5135135 L41.5135135,41.5135135 L41.5135135,6.81081081 L6.81081081,6.81081081 Z M28.8648649,11.6756757 L37.6216216,11.6756757 L19.4594595,36.6486486 L10.7027027,36.6486486 L28.8648649,11.6756757 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDbLogo);
export default __webpack_public_path__ + "static/media/db_logo.5db8d94502cb7668841a102a9156c5a4.svg";
export { ForwardRef as ReactComponent };